import I18n from 'js/lib/i18n.js.erb'
;(function ($) {
  $.petrescue.init('.cards-common-subscribe-newsletter', function () {
    $('.cards-common-subscribe-newsletter .button').on('click', function (e) {
      e.preventDefault()
      var $emailInput = $('.cards-common-subscribe-newsletter input.email')
      var listSubscriptionAttributes = {
        email: $emailInput.val(),
      }

      $emailInput.parent().removeClass('error')
      $('.cards-common-subscribe-newsletter__subscribe_confirm').empty()

      if ($('#animal_welfare_segment').length > 0) {
        $.extend(listSubscriptionAttributes, {
          animal_welfare_strategy: true,
        })
      }

      if ($('.cards-common-subscribe-newsletter__petrescue_post').length > 0) {
        $.extend(listSubscriptionAttributes, {
          petrescue_post: true,
        })
      }

      $.ajax({
        type: 'POST',
        url: '/list_subscriptions',
        dataType: 'json',
        data: {
          list_subscription: listSubscriptionAttributes,
          list_type: 'core',
        },
        success: function () {
          $('.cards-common-subscribe-newsletter input.email').val('')

          $.petrescue.flash('notice', I18n.t('cards.common.subscribe_newsletter.messages.success'))
        },
        error: function () {
          $emailInput.parent().addClass('error').focus()
        },
      })
    })
  })
})(jQuery)
